import { ValidatorFn, AbstractControl } from '@angular/forms';

export function fileSizeValidator(priorSize?): ValidatorFn {
  return (control: AbstractControl) => {
  const size = control ? control.value ? control.value.size ? control.value.size : priorSize : priorSize : priorSize;
  if (size > 41943040 || size === undefined) {
      return {
        sizeInvalid: true
      };
    }
  return null;
  };
}
